import { useSelector } from 'react-redux';

import { selectIsAssignmentReady } from '@glass/common/modules/assignments/redux';

const useIsAssignmentReady = () => useSelector(selectIsAssignmentReady);

export default useIsAssignmentReady;
